import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const StParagraph = styled.p<{ width?: string }>`
    font-size: 14px;
    font-weight: bold;
    letter-spacing: normal;
    padding: 0;
    width: ${props => props.width ?? 'auto'};
`;

const StDiv = styled.div`
    display: flex;
    justify-content: start;
    align-items: start;
`;

export const TableRow = ({ product }) => {
    const { id, title, isbn13 } = product;

    if (title) {
        return (
            <StDiv key={id}>
                <StParagraph width={'30%'}> {isbn13} </StParagraph>
                <StParagraph width={'60%'}> {title} </StParagraph>
            </StDiv>
        );
    }
    return (
        <StDiv key={id}>
            <StParagraph>{id}</StParagraph>
        </StDiv>
    );
};

export const ExpandableTable = ({ products }) => {
    const { t } = useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);
    const tableRef = useRef<HTMLDivElement>(null);
    const displayedProducts = isExpanded ? products : products.slice(0, 5);

    useEffect(() => {
        if (tableRef.current) {
            if (tableRef.current?.offsetHeight > 50 && isExpanded) {
                tableRef.current.classList.add('scroll-table');
            } else {
                tableRef.current.classList.remove('scroll-table');
            }
        }
    }, [tableRef, isExpanded]);

    return (
        <>
            <div ref={tableRef} className="products-wrapper">
                {displayedProducts.map(product => (
                    <TableRow product={product} key={product.id} />
                ))}
            </div>

            {products.length > 5 ? (
                <button className="see-more" onClick={() => setIsExpanded(!isExpanded)}>
                    {isExpanded ? (
                        <span>{t('components.checkBeforeAddingModal.seeLess')}</span>
                    ) : (
                        <span>{t('components.checkBeforeAddingModal.seeAll')}</span>
                    )}
                    {isExpanded ? (
                        <i className="material-icons">expand_less</i>
                    ) : (
                        <i className="material-icons">expand_more</i>
                    )}
                </button>
            ) : null}
        </>
    );
};
